
    import './styles.scoped.css';
    export default {
  "dropdown-footer": "awsui_dropdown-footer_vm8qf_skw04_9",
  "dropdown-content": "awsui_dropdown-content_vm8qf_skw04_14",
  "token-field-container": "awsui_token-field-container_vm8qf_skw04_18",
  "token-field": "awsui_token-field_vm8qf_skw04_18",
  "token-field-disabled": "awsui_token-field-disabled_vm8qf_skw04_54",
  "token-field-readonly": "awsui_token-field-readonly_vm8qf_skw04_62",
  "token-field-invalid": "awsui_token-field-invalid_vm8qf_skw04_68",
  "token-field-warning": "awsui_token-field-warning_vm8qf_skw04_80",
  "grouped": "awsui_grouped_vm8qf_skw04_92",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_vm8qf_skw04_99",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_vm8qf_skw04_103",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_vm8qf_skw04_109",
  "grouped-vertical-first": "awsui_grouped-vertical-first_vm8qf_skw04_113",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_vm8qf_skw04_117",
  "grouped-vertical-last": "awsui_grouped-vertical-last_vm8qf_skw04_123",
  "grouped-with-action": "awsui_grouped-with-action_vm8qf_skw04_127",
  "grouped-with-error": "awsui_grouped-with-error_vm8qf_skw04_131",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_vm8qf_skw04_159",
  "grouped-vertical-only": "awsui_grouped-vertical-only_vm8qf_skw04_159",
  "grouped-with-warning": "awsui_grouped-with-warning_vm8qf_skw04_165",
  "grouped-row-first": "awsui_grouped-row-first_vm8qf_skw04_199",
  "token-field-icon": "awsui_token-field-icon_vm8qf_skw04_226",
  "token-list": "awsui_token-list_vm8qf_skw04_232",
  "inline-tokens": "awsui_inline-tokens_vm8qf_skw04_246",
  "token-list-item": "awsui_token-list-item_vm8qf_skw04_250",
  "token-input-wrapper": "awsui_token-input-wrapper_vm8qf_skw04_254",
  "token-overflow": "awsui_token-overflow_vm8qf_skw04_261",
  "token-overflow-trigger": "awsui_token-overflow-trigger_vm8qf_skw04_265",
  "overflow-dropdown": "awsui_overflow-dropdown_vm8qf_skw04_269",
  "overflow-dropdown-item": "awsui_overflow-dropdown-item_vm8qf_skw04_278",
  "measurement-container": "awsui_measurement-container_vm8qf_skw04_284",
  "measurement-token": "awsui_measurement-token_vm8qf_skw04_297"
};
  